import { Tools } from "@carbon/pictograms-react";
import { Kubernetes } from "@carbon/pictograms-react";
import { ArtTools_01 } from "@carbon/pictograms-react";
import * as React from 'react';
export default {
  Tools,
  Kubernetes,
  ArtTools_01,
  React
};